import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles.css';
import App from './App';
import { initScrollReveal } from './utils/scrollReveal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Initialize scroll reveal animations
setTimeout(() => {
  initScrollReveal();
}, 100);

